/**
* @Author: Michael Neumair <mBook>
* @Date:   2016-08-22T17:06:23+02:00
* @Email:  7q7w7e7r@gmail.com
* @Last modified by:   mBook
* @Last modified time: 2016-10-10T16:09:34+02:00
*/


import React, {Component} from 'react';
import PropTypes from 'prop-types';

/**
 * ALabelInput - …
**/
class ALabelInput extends Component {
  render() {
    const {
      htmlFor,
      label,
      children = label,
      ...other
    } = this.props;
    return (
      <label
        {...other}
        htmlFor={htmlFor}
        className="a-label a-label-input"
      >
        {children}
      </label>
    );
  }
}

ALabelInput.propTypes = {
  /**
     * name of the input the label is for
     */
  htmlFor: PropTypes.string,
  /**
     * label and children are the same
     */
  label: PropTypes.string,
  children: PropTypes.any,
};
ALabelInput.defaultProps = {};
export default ALabelInput;

